export const GET_TOKEN = 'GET_TOKEN';
export const GET_RESET_PASSWORD_TOKEN = 'GET_RESET_PASSWORD_TOKEN';
export const SET_MFA_STATUS = 'setMfaStatus';
export const SET_TWO_FACTOR_AUTH_REQUIRED = 'setTwoFactorAuthRequired';
export const REMOVE_TWO_FACTOR_AUTH_REQUIRED = 'removeTwoFactorAuthRequired';
export const RESET_STATE = 'resetState';
